export interface IMakeUserPatronRequest {
    userId: string;
    patronType: PatronType;
}

export enum PatronType {
    Patron,
    PatronLight
}